import React from 'react';
import { Tabs } from '../../../ui/Tabs';
import * as styles from './mediaCenter.styles';

export type MediaCenterTab = 'photos' | '3dtour' | 'videos';

type MediaCenterTabsProps = {
  activeTab: MediaCenterTab;
  onTabChange: (tab: MediaCenterTab) => void;
  has3dTour: boolean;
  hasVideos?: boolean;
};

export const MediaCenterTabs = ({ activeTab, onTabChange, has3dTour, hasVideos }: MediaCenterTabsProps) => {
  const tabs = [
    { id: 'photos', label: 'Photos' },
    { id: '3dtour', label: '3D Tour', disabled: !has3dTour },
    { id: 'videos', label: 'Videos', disabled: !hasVideos },
  ].filter((tab) => !tab.disabled);

  return (
    <Tabs
      tabs={tabs}
      activeTabId={activeTab}
      onTabChange={(id) => onTabChange(id as MediaCenterTab)}
      ariaLabel="Media types"
      idPrefix="tab"
      className={styles.tabsContainerOverride}
    />
  );
};
